import React, { useState } from 'react'
import { useCreateRegionMutation, useUpdateRegionMutation } from '../Service/regionsApi';
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';
import { regionValues } from '../initialValues';
import { regionFields } from '../fields';
import { RegionsRoutes } from '../../../Router/path';
import { FormRenderGroupTypes } from '../../Shared/Components/FormRenderer/FormRenderGroup.types';
import SettingsIcon from "@mui/icons-material/Settings";
import InfoIcon from "@mui/icons-material/Info";
import EntityFormLayout from '../../Shared/Components/EntityFormLayout/EntityFormLayout';
import { useGetCountriesQuery } from '../../Countries/Service/countriesApi';
import { Region } from '../Types/regionTypes';

const CreateRegion = () => {
    const [createdRegionId, setCreatedRegionId] = useState<number | null>(null);
    const [createRegion, createStatus] = useCreateRegionMutation();
    const [updateRegion, updateStatus] = useUpdateRegionMutation();

    const mutationStatus = createdRegionId ? updateStatus : createStatus;

    const { data: countries, isLoading: countriesLoading } = useGetCountriesQuery();

    const entityForm = useEntityForm<Region>({
        initialData: regionValues,
        fields: regionFields.map((field) => {
            if (field.type === "autocomplete" && countries) {
                return {
                    ...field,
                    name: field.name as keyof Region,
                    options: countries.map((country) => ({
                        label: country.name,
                        value: country.id,
                    })),
                    loading: countriesLoading,
                };
            }
            return field;
        }),
        submitFn: (data) => {
            if (createdRegionId) {
                return updateRegion({ id: createdRegionId, data }).unwrap();
            } else {
                return createRegion(data).unwrap();
            }
        },
        redirectUrl: RegionsRoutes.root,
        title: "Dodaj region",
        icon: <></>,
        backUrl: RegionsRoutes.root,
        groupOrder: [
            FormRenderGroupTypes.basic,
            FormRenderGroupTypes.configuration,
        ],
        groupIcons: {
            Podstawowe: <InfoIcon sx={{ color: theme => theme.palette.primary.main }} />,
            Konfiguracja: <SettingsIcon sx={{ color: theme => theme.palette.primary.main }} />,
        },
        mutationStatus: mutationStatus,
        showSuccessBeforeRedirect: true,
        redirectDelay: 2000,
        onSuccessWithResponse: (response, shouldRedirect) => {
            if (!shouldRedirect) {
                setCreatedRegionId(response.regionId);
            }
        },
    })
    return (
        <EntityFormLayout {...entityForm}>

        </EntityFormLayout>
    )
}

export default CreateRegion